import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Tooltip from '@mui/material/Tooltip'
import { useRoutingContext } from '../../hooks/use-routing-context'

const RouteSuggestionButton: React.FC = () => {
  const context = useRoutingContext()
  const [loading, setLoading] = useState(false)
  const allMembersHaveAddresses = context.selectedMembers.every(member => {
    const config = context.memberConfigurations[member.id]
    return config?.initial?.latitude && config?.initial?.longitude &&
           config?.final?.latitude && config?.final?.longitude
  })

  const canProceed =
    context.date && context.workingHours.startTime && context.workingHours.endTime &&
    context.selectedWorks.length >= 2 && context.selectedMembers.length >= 1 &&
    !context.workingHours.startTimeError && !context.workingHours.endTimeError &&
    Object.keys(context.workDurations).length === context.selectedWorks.length &&
    !Object.values(context.durationErrors).some(error => error !== null) &&
    allMembersHaveAddresses

  const { setActiveStep, loadRouteSuggestion, setRouteSuggestions, setUnassignedWorkIds, setUnassignedMemberIds, setSelectionError } = context

  const handleCreateRoute = async () => {
    if (canProceed) {
      setSelectionError(null)
      setLoading(true)
      const startTime = context.date.hour(context.workingHours.startTime.hour()).minute(context.workingHours.startTime.minute()).second(0).millisecond(0)
      const endTime = context.date.hour(context.workingHours.endTime.hour()).minute(context.workingHours.endTime.minute()).second(0).millisecond(0)
      const routeData = {
        startTime: startTime.toString(),
        endTime: endTime.toString(),
        works: context.selectedWorks.map(work => ({
          ...work,
          duration: context.workDurations[work.id] ? context.workDurations[work.id].hour() * 60 + context.workDurations[work.id].minute() : null
        })),
        members: context.selectedMembers.map(member => ({
          ...member,
          configuration: context.memberConfigurations[member.id] || null
        })),
      }
      try {
        const { suggestions, unassignedWorkIds, unassignedMemberIds } = await loadRouteSuggestion.load(routeData)
        setRouteSuggestions(suggestions)
        setUnassignedWorkIds(unassignedWorkIds)
        setUnassignedMemberIds(unassignedMemberIds)
        setActiveStep(1)
      } catch (error) {
        setSelectionError({ message: error.message, reason: error.reason, references: error.references, unassignedMemberIds: error.unassignedMemberIds })
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} data-testid="create-route-button">
      <Tooltip
        title={'Preencha os campos obrigatórios para continuar'}
        placement="top" 
        arrow
        disableHoverListener={canProceed}
      >
        <span>
          <Button
            onClick={handleCreateRoute}
            disabled={!canProceed || loading}
            variant='contained'
            startIcon={loading ? <CircularProgress size={16} color='inherit' /> : null}
          >
            Criar rota
          </Button>
        </span>
      </Tooltip>
    </Box>
  )
}

export default RouteSuggestionButton
